import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './guard/auth.guard';
import { PortalComponent } from './pages/portal/portal.component';
import { coneoWdRoot } from './function-modules/coneo-wd/coneo-wd.config';
import { StockTriage } from './function-modules/stock-triage/pages/stock-triage/stock-triage.component';
import { coneoWd2cRoot } from './function-modules/coneo-wd2c/coneo-wd2c.config';

/**
 * ルーティング設定
 */
const ROUTER_DEFINITION: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, data: { animation: '0' } },
  { path: 'portal', component: PortalComponent, canActivate: [AuthGuard], data: { animation: '1'}},
  {
    path: 'users',
    loadChildren: './function-modules/users/users.module#UsersModule'
  },
  // CONEO-WD
  {
    path: coneoWdRoot,
    loadChildren: './function-modules/coneo-wd/coneo-wd.module#ConeoWdModule'
  },
  // CONEO-WD2C
  {
    path: coneoWd2cRoot,
    loadChildren: './function-modules/coneo-wd2c/coneo-wd2c.module#ConeoWd2cModule'
  },
  //   StockTriage
  {
    path: 'stock-triage', component: StockTriage
  },
  // ロジKPI
  {
    path: 'logi-kpi',
    loadChildren: './function-modules/logi-kpi/logi-kpi.module#LogiKpiModule'
  },
  { path: '**', component: PageNotFoundComponent, data: { animation: '99' } }
];

@NgModule({
  exports: [ RouterModule ],
  imports: [
    RouterModule.forRoot(ROUTER_DEFINITION, { useHash: true }),
  ]
})
export class AppRoutingModule {}
